import './index.less';
import './i18n/index';

import { createRoot } from 'react-dom/client';

import SubAccountLogin from './pages/subAccountLogin';

const container = document.getElementById('subAccountLoginontent')!;
createRoot(container).render(<SubAccountLogin />);
